// extracted by mini-css-extract-plugin
module.exports = {"details":"id_details__Yuap9","itemsGradual":"id_itemsGradual__4WvAR","itemsPlate":"id_itemsPlate__1rTIu"};